import { Box, Text } from '@/ui';

type Props = {
  description?: string;
  title: string;
};

export const SectionHeader = ({ title, description }: Props) => (
  <Box mb={6}>
    <Text
      color="ink.strong"
      fontFamily="display"
      fontSize="2xl"
      fontWeight={700}
      letterSpacing="-0.02em"
      mb={description ? 1.5 : 0}
    >
      {title}
    </Text>
    {description && (
      <Text color="ink.muted" fontSize="ah-control" lineHeight={1.55}>
        {description}
      </Text>
    )}
  </Box>
);
